import { Grid, TextInput, ActionIcon } from "@mantine/core";
import { IconTrash } from "@tabler/icons";

export interface IAttorneyRowProps {
    onDeleteClick: () => void;
    onAttorneyChange: (text: string) => void;
    attorney: string;
}

export default function AttorneyRow(props: IAttorneyRowProps) {
    return (
        <Grid>
            <Grid.Col span={1}>
                <ActionIcon onClick={props.onDeleteClick}><IconTrash /></ActionIcon>
            </Grid.Col>

            <Grid.Col span={11}>
                <TextInput placeholder="Attorney" value={props.attorney} onChange={(event) => { props.onAttorneyChange(event.target.value); }} />
            </Grid.Col>
        </Grid>
    );
}